import React from "react";
export const Appcontext = React.createContext();